import styled from "styled-components";

export const Figure = styled.figure`
    display: flex;
    column-gap: 8px;
    align-items: center;
    justify-content: center;
    margin: 0;
`;
